import { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

const money = (v) => (v || 0).toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const MONTHS = ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"];
const label = (m) => `${MONTHS[+m.slice(5) - 1]} ${m.slice(2, 4)}`;

export const RevenueChart = () => {
  const [d, setD] = useState(null);
  const [cur, setCur] = useState(null);
  useEffect(() => {
    api.get("/reports/revenue-12m").then((r) => { setD(r.data); setCur(Object.keys(r.data.by_currency)[0] || null); }).catch(() => {});
  }, []);
  if (!d) return null;
  const currencies = Object.keys(d.by_currency);
  const rows = cur ? d.by_currency[cur].map((x) => ({ ...x, label: label(x.month) })) : [];
  return (
    <section className="mt-8 border border-border bg-white rounded-md p-5" data-testid="revenue-chart-panel">
      <div className="flex items-center gap-2 flex-wrap mb-4">
        <TrendingUp className="h-4 w-4 text-[#193962]" />
        <h3 className="font-[Outfit] font-semibold">Przychody – ostatnie 12 miesięcy</h3>
        <span className="text-[11px] text-muted-foreground">netto · faktury + korekty</span>
        <div className="flex gap-1.5 ml-auto" data-testid="revenue-currency-switch">
          {currencies.map((c) => (
            <button key={c} onClick={() => setCur(c)} data-testid={`revenue-currency-${c}`}
              className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${c === cur ? "bg-[#193962] text-white border-[#193962]" : "border-border text-zinc-600 hover:bg-zinc-50"}`}>{c}</button>
          ))}
        </div>
      </div>
      {!cur ? (
        <p className="text-sm text-muted-foreground py-8 text-center" data-testid="revenue-chart-empty">Brak wystawionych faktur w ostatnich 12 miesiącach.</p>
      ) : (
        <>
          <div className="flex gap-6 mb-3 text-sm" data-testid="revenue-totals">
            <span>Zafakturowano: <b className="tabular-nums" data-testid="revenue-total-invoiced">{money(d.totals[cur].invoiced)} {cur}</b></span>
            <span>Opłacono: <b className="tabular-nums text-emerald-700" data-testid="revenue-total-paid">{money(d.totals[cur].paid)} {cur}</b></span>
          </div>
          <div className="h-64" data-testid="revenue-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={rows} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e4e4e7" />
                <XAxis dataKey="label" tick={{ fontSize: 11 }} interval="preserveStartEnd" minTickGap={8} />
                <YAxis tick={{ fontSize: 11 }} width={70} tickFormatter={(v) => v.toLocaleString("pl-PL")} />
                <Tooltip formatter={(v) => `${money(v)} ${cur}`} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Bar dataKey="invoiced" name="Zafakturowano" fill="#193962" radius={[3, 3, 0, 0]} />
                <Bar dataKey="paid" name="Opłacono" fill="#10b981" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      )}
    </section>
  );
};
